// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"928b5f7a","310":"c59c7888","504":"aa9f9e1a","585":"0df1eb2d","783":"e57a6135"}[chunkId] + ".chunk.js";
};